module.exports = __webpack_public_path__ + "static/img/btn_action_en@2x.51303bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/UID/btn_action_en@2x.png
// module id = KYy9
// module chunks = 1